import React from 'react';
import { Container } from 'bulma-react';
import {
  Editor,
} from '../components';

export function Edit(props) {
  return (
    <Container className="app">
      <Editor id={props.match.params.id} history={props.history}/>
    </Container>
  );
}




// WEBPACK FOOTER //
// ./src/container/edit.js